// extracted by mini-css-extract-plugin
export default {"forumPostList":"mWXmD0S95E9a11NHTJ_Q","profilesListSection":"Sv8pVTFPeOvpa5ewhF30","profilesListWrapper":"QQKMKHxvIWOUYwxZsrIR"};